import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'oxylance',
} as IModuleProps;
